import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import LogoPostosGo from "images/logo_postosgo.png";
import List from "@mui/material/List";
import Drawer from "@mui/material/Drawer";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InstagramIcon from "@mui/icons-material/Instagram";
import ModalPrivacyPolicy from "components/ModalPrivacyPolicy";
import { Divider, Link } from "@mui/material";

export default function DenseAppBar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation">
      <List>
        <Link href="https://www.instagram.com/postosgo/" target="_blank" underline="none" style={{ color: 'inherit' }} onClick={toggleDrawer(false)}>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <InstagramIcon />
            </ListItemIcon>
            <ListItemText primary={"Instagram"} />
          </ListItemButton>
        </ListItem>
        </Link>
        <Divider />
        <ListItem disablePadding>
          <ModalPrivacyPolicy />
        </ListItem>
        <Divider />
      </List>
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar variant="dense">
          <Box sx={{ mx: "auto", height: "4vh", py: "10px" }}>
            <img src={LogoPostosGo} height={"100%"} />
          </Box>
          <IconButton
            onClick={toggleDrawer(true)}
            edge="end"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer anchor="right" open={open} style={{ zIndex: 9999999999 }} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </Box>
  );
}
